import httpService from "@/utils/services/http_service";

export default {
  /**
   * @author: zhengyongbo
   * date: 2020-02-02
   *  登录
   */
  async login(data = {}) {
    return httpService.post(
      '/api.php?do=admin_member_login',
      data
    )
  },

  /**
   * @author: zhengyongbo
   * date: 2020-02-02
   *  退出登录
   */
  async logout(data = {}) {
    return httpService.post(
      '/api.php?do=admin_member_logout',
      data
    )
  },

  /**
   * @author: zhengyongbo
   * date: 2020-02-02
   *  登录后获取个人信息
   */
  async getMyUserInfo(data = {}) {
    return httpService.post(
      '/api.php?do=admin_member_myinfo',
      data
    )
  },

  /**
   * @author: zhengyongbo
   * date: 2020-02-06
   *  修改密码
   */
  async changPassword(data = {}) {
    return httpService.post(
      '/api.php?do=admin_member_change_my_password',
      data
    )
  },

  /**
   * @author: zhengyongbo
   * date: 2020-02-06
   *  修改密码
   */
  async uploadFile(data = {}) {
    return httpService.post(
      '/api.php?do=admin_file_upload',
      data
    )
  }
}
